import type { ReactNode } from 'react'
import React, { useState } from 'react'
import { Alert, csx } from '@vtex/admin-ui'

export type PackageAlertProps = {
  children: ReactNode
}

export const PackageAlert = ({ children }: PackageAlertProps) => {
  const [isVisible, setIsVisible] = useState(true)

  if (!isVisible) {
    return null
  }

  return (
    <div
      className={csx({
        // Thanks admin-ui!
        '> div': {
          height: 'auto',
        },
      })}
    >
      <Alert
        variant="warning"
        className={csx({ height: 'auto' })}
        onDismiss={() => setIsVisible(false)}
      >
        {children}
      </Alert>
    </div>
  )
}
